import InsuranceBronze from "./InsuranceBronze";
import InsuranceSilver from "./InsuranceSilver";
import InsuranceGold from "./InsuranceGold";
import React from "react";
import {Typography} from "@mui/material";

export default function InsuranceModal({insurance}) {

    if(!insurance) {
        return (
            <Typography variant="h5">
                Voce não tem um plano
            </Typography>
        )
    }

    if(insurance === 12) {
        return <InsuranceBronze />
    }

    if (insurance === 24) {
        return <InsuranceSilver />
    }

    if (insurance === 36) {
        return <InsuranceGold />
    }
}